/**
 * Claims & budgets: Admin, Team Leader (management_id 1), or Treasurer (management_id 3) manage all rows.
 * Other members may only act on records where user_id matches their id.
 */

export function canManageAllClaims(user) {
  if (!user) return false;
  if (user.is_admin) return true;
  const isTL = Boolean(user.is_team_leader) || Number(user.management_id) === 1;
  const isTreasurer = Number(user.management_id) === 3;
  return isTL || isTreasurer;
}

export function canManageAllBudgets(user) {
  if (!user) return false;
  const isTL = Boolean(user.is_team_leader) || Number(user.management_id) === 1;
  const isTreasurer = Number(user.management_id) === 3;
  return isTL || isTreasurer;
}

export function canEditClaim(user, claim) {
  if (!user || !claim) return false;
  if (canManageAllClaims(user)) return true;
  const ownerId = claim.user_id ?? claim.created_by;
  if (Number(ownerId) !== Number(user.id)) return false;
  return claim.status === 'on_hold';
}

/** Team Leader / Treasurer may reject pending claims. */
export function canRejectClaim(user, claim) {
  if (!canManageAllClaims(user) || !claim) return false;
  return claim.status === 'pending';
}

/** User-facing message when edit is blocked (null = allowed). */
export function claimEditBlockedMessage(user, claim) {
  if (!user || !claim) return 'You don\'t have permission to edit this claim.';
  if (canManageAllClaims(user)) return null;
  const ownerId = claim.user_id ?? claim.created_by;
  if (Number(ownerId) !== Number(user.id)) {
    return 'You don\'t have permission to edit this claim.';
  }
  if (claim.status !== 'on_hold') {
    return 'You can only edit this claim after a Team Leader or Treasurer puts it on hold.';
  }
  return null;
}

export function canEditBudget(user, budget) {
  if (!user || !budget) return false;
  if (canManageAllBudgets(user)) return true;
  return Number(budget.user_id) === Number(user.id);
}
